import { CLEAR, REPLACE, SET_STOCK_CONTROLS_FILTERS, SET_STOCK_CONTROLS_PAGENUMBER, SET_STOCK_CONTROLS_PAGESIZE } from "./actions"

const initialState = {
    stockControls : [],
    totalResults: 0,
    totalPage: 1,
    pageSize: 10,
    pageNumber: 1,
    filters: {
        from: '',
        to: '',
    }
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE:
            return {
                ...state,
                stockControls: action.stockControls,
                totalResults: action.totalResults,
                totalPage: action.totalPage
            }
        case SET_STOCK_CONTROLS_FILTERS:
            return {
                ...state,
                pageNumber: 1,
                filters: {
                    ...state.filters,
                    ...action.filters
                }
            }
        case SET_STOCK_CONTROLS_PAGESIZE:
            return {
                ...state,
                pageSize: action.pageSize
            }
        case SET_STOCK_CONTROLS_PAGENUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber
            }
        case CLEAR:
            return initialState
        default:
            return state;
    }
}